import { Card, CardContent } from "./ui/card";


export default function StatCard({ label, value, accent, helper, testId }) {
  return (
    <Card className="border-slate-200/70 bg-white/85 shadow-[0_18px_45px_rgba(15,23,42,0.06)]" data-testid={testId}>
      <CardContent className="space-y-3 p-5">
        <div className="flex items-center justify-between gap-3">
          <p className="text-xs font-semibold uppercase tracking-[0.26em] text-slate-400" data-testid={`${testId}-label`}>{label}</p>
          <span className="h-3 w-3 rounded-full" style={{ backgroundColor: accent }} data-testid={`${testId}-accent`} />
        </div>
        <p className="text-3xl font-extrabold tracking-tight text-slate-900" data-testid={`${testId}-value`}>{value}</p>
        <p className="text-sm text-slate-500" data-testid={`${testId}-helper`}>{helper}</p>
      </CardContent>
    </Card>
  );
}